export enum SolutionType {
  HoloView = 'holoview',
  HoloKine = 'holokine',
}

export const SOLUTION_TYPE_LABELS: Record<SolutionType, string> = {
  [SolutionType.HoloView]: '幻维',
  [SolutionType.HoloKine]: '幻康',
}

export const CLIENT_ONLY_SOLUTION_MESSAGE = '幻康工程请使用客户端查看文件'

export function normalizeSolutionType(value: unknown): SolutionType {
  const raw = String(value ?? '').trim()
  if (!raw || raw === SolutionType.HoloView) return SolutionType.HoloView
  if (raw === SolutionType.HoloKine) return SolutionType.HoloKine
  throw new Error(`Unknown Solution Type: ${raw}`)
}

export function isClientOnlySolutionType(value: unknown): boolean {
  return normalizeSolutionType(value) === SolutionType.HoloKine
}

export class ClientOnlySolutionError extends Error {
  readonly solutionType = SolutionType.HoloKine

  constructor() {
    super(CLIENT_ONLY_SOLUTION_MESSAGE)
    this.name = 'ClientOnlySolutionError'
  }
}

